
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"40","cy":"40","r":"40","fill":"#F9BEF9"}}),_c('rect',{attrs:{"x":"21","y":"21","width":"38","height":"38","rx":"4","fill":"#2A4494"}}),_c('path',{attrs:{"d":"M51.236 59H28.764a.759.759 0 01-.54-.227.78.78 0 01-.224-.547 12.422 12.422 0 011.286-5.55 12.243 12.243 0 013.618-4.363 2.552 2.552 0 012.673-.263 9.594 9.594 0 004.408 1.074 9.594 9.594 0 004.407-1.074 2.537 2.537 0 012.689.263 12.178 12.178 0 013.612 4.316A12.358 12.358 0 0152 58.133a.874.874 0 01-.217.582.852.852 0 01-.547.285zM39.978 46.408a8.502 8.502 0 01-4.77-1.467 8.68 8.68 0 01-3.162-3.906 8.816 8.816 0 01-.488-5.029 8.742 8.742 0 012.35-4.457 8.55 8.55 0 014.395-2.382 8.477 8.477 0 014.96.496 8.612 8.612 0 013.854 3.205 8.808 8.808 0 01.793 8.167 8.714 8.714 0 01-1.86 2.824 8.58 8.58 0 01-2.786 1.887 8.484 8.484 0 01-3.286.662z","fill":"#fff"}})])
          )
        }
      }
    